export const CONTACT_EMAIL: string = 'contact@underlayer.ai'

// The Calendly slug is "30min" (the underlying event's internal name) but
// the meeting itself is 20 minutes — never surface "30 min" in the UI, use
// TALK_TO_US_LABEL everywhere instead.
export const TALK_TO_US_URL: string = 'https://calendly.com/justin-reverdi/30min'
export const TALK_TO_US_LABEL: string = 'Talk to us - 20 min'
///@brief   Label of the demo booking button (menu, contact page).
export const BOOK_DEMO_LABEL: string = 'Book a demo'
///@brief   Short form of the call, for the hero.
export const TALK_TO_US_SHORT_LABEL: string = 'Talk to us'
///@brief   Trial button of the hero and of every pricing card, leading to
///         the request form.
export const TRY_FREE_LABEL: string = 'Try underlayer'
export const TRY_FREE_PATH: string = '/request-demo'

///@brief   Query parameter of the request form naming the plan the visitor
///         clicked on the way there. The form sends it along with the email,
///         so a request from a pricing card says which card it was. The home
///         page's button carries none: nothing was chosen yet.
export const TRIAL_PLAN_PARAM: string = 'plan'

///@brief   The request form's path, with `plan` on it.
export function trialPathFor( plan: string ): string {
	return `${ TRY_FREE_PATH }?${ TRIAL_PLAN_PARAM }=${ encodeURIComponent( plan ) }`
}
